import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { MasterFleetManagerForm } from "./MasterFleetManagerForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface IMasterFleetManagerCreateProps {}

export const MasterFleetManagerCreate = (
  props: IMasterFleetManagerCreateProps
) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.master-fleet-managers.title.create">
      <MasterFleetManagerForm />
    </Create>
  );
};
